import React, { useEffect } from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import { useTranslation } from 'react-i18next'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import { Row, Col, ListGroup, ListGroupItem } from 'reactstrap'
import Select from 'react-select'
import moment from 'moment'
import resCn from 'lib/responsive_classes'

const AccessModule = (props) => {
  const { config, machine, status, resSize } = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { days_available } = config
  const { selection_groups } = current.context

  useEffect(() => {
    registerLocale('es', es)
  }, [])

  const SelectionGroup = (data) => {
    const { id, name, event_groups, access_date, session, event_group } = data

    const SessionSelector = ({ events }) => {
      const eventsList = events.map((e) => ({
        value: e.id,
        label: moment(e.date).format('LT')
      }))

      return (
        <Select
          className="text-dark"
          options={eventsList}
          value={eventsList.find((e) => e.value === session)}
          onChange={(event) =>
            send({
              type: 'SESSION_CHANGE',
              selection_group_id: id,
              session_id: event.value
            })
          }
        />
      )
    }

    const SessionGroupSelector = () => {
      const selection_group_id = id

      return (
        <ListGroup>
          <ListGroupItem color="info">
            <strong>{i18n.t('access_module.select_session_time')}</strong>
          </ListGroupItem>
          {event_groups.map(({ id, name, events }) => (
            <ListGroupItem
              key={id}
              color={event_group === id ? 'warning' : ''}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (event_group === id) return
                send({
                  type: 'EVENT_GROUP_CHANGE',
                  selection_group_id,
                  event_group: id
                })
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="p-2">{name}</div>
                {event_group === id && (
                  <div style={{minWidth: '135px'}}>
                    <SessionSelector events={events} />
                  </div>
                )}
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      )
    }

    return (
      <div className="card">
        <div className="card-body">
          <Row>
            <Col className={resCn({ 
              wide: 'col-md-6', 
              slim: 'col-12' 
            }, resSize)}>
              <h5 className={resCn({ 
                wide: 'card-title text-md-start', 
                slim: 'card-title text-center' 
              }, resSize)}>
                {name}
              </h5>
              <div className={resCn({ 
                wide: 'justify-content-md-start', 
                slim: 'justify-content-center',
                all: 'd-flex'
              }, resSize)}>             
                <DatePicker
                  className="form-control"
                  locale="es"
                  selected={access_date}
                  filterDate={(date) =>
                    days_available
                      ? days_available.includes(moment(date).format('YYYY-MM-DD'))
                      : true
                  }
                  onChange={(date) =>
                    send('ACCESS_DATE_CHANGE', { id, day: date })
                  }
                  dateFormat="P"
                />
              </div>
              <div className={resCn({ 
                wide: 'mt-md-2 mb-md-0 text-md-start', 
                slim: 'mt-3 mb-2 fw-bold text-center',
                all: ''
              }, resSize)}>
                {moment(access_date).format('LL')}
              </div>
            </Col>
            <Col className={resCn({ 
              wide: 'col-md-6', 
              slim: 'col-12' 
            }, resSize)}>
              {event_groups.length > 0 && <SessionGroupSelector />}
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_ACCESSSTEP') : null
        }
      >
        <span>
          <i className="fa fa-question-circle me-2" aria-hidden="true"></i>
          {i18n.t('access_module.title')}
        </span>
      </ModuleHeader>

      <ModuleBody status={status}>
        {current.matches({ accessStep: 'waitingEventsPick' }) &&
          selection_groups.length === 0 && (
            <div className="alert alert-light" role="alert">
              {i18n.t('event_module.events_not_available')}
            </div>
          )}

        {selection_groups.map((selectionGroup) => (
          <SelectionGroup key={selectionGroup.id} {...selectionGroup} />
        ))}
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default AccessModule
